import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  OrderformOrderStateMessageNotification,
  OrderformOrderStateMessageNotificationAction,
  OrderformPartialState,
} from '@orderform/widgets';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { filter, map, switchMap } from 'rxjs/operators';
import * as OrderformActions from '../../ngrx/orderform.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'orderform-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent implements OnInit {
  notifications$: Observable<OrderformOrderStateMessageNotification[]> =
    this._orderformFacade.isEditor$.pipe(
      filter((editor) => editor === false),
      switchMap(() =>
        this._orderformFacade.messages$.pipe(
          map((messages) => messages.notifications)
        )
      )
    );

  modalClosed: { [index: number]: true } = {};
  trackBy = (i) => i;

  constructor(
    private _orderformFacade: OrderformFascade,
    private _cdr: ChangeDetectorRef,
    private _store: Store<OrderformPartialState>
  ) {}

  ngOnInit() {}

  executeAction(
    notify: OrderformOrderStateMessageNotificationAction,
    modalIndex: number
  ) {
    if (notify.url) {
      window.open(notify.url, '_blank');
    }
    if (notify.ajax_url) {
      this._store.dispatch(
        OrderformActions.callGenericAjaxUrlRequest({ ajaxUrl: notify.ajax_url })
      );
    }
    this.modalClosed[modalIndex] = true;
    this._cdr.detectChanges();
  }
}
